//src/services/priceVisibility.api.js
import { apiRequest } from "./api";
import { adminApiRequest } from "./adminApi";

export const getPriceVisibility = () => {
  return apiRequest("/price-visibility");
};

export const getAdminPriceVisibility = () => {
  return adminApiRequest("/admin/price-visibility");
};

export const toggleAdminPriceVisibility = () => {
  return adminApiRequest("/admin/price-visibility/toggle", {
    method: "POST",
  });
};
